import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormikErrors } from "formik";
import { Col, Label, UncontrolledTooltip } from "reactstrap";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { toast } from "react-toastify";
import { ICourse } from "api/types/_params";
import DatePicker from "react-datepicker";
import DropdownAsyncCourse from "components/Common/DropdownAsyncCourse";
import ModalConfirm from "components/Common/ModalConfirm";
import { LIST_LANGUAGE_OPTION } from "helpers/constans";
import TooltipCustom from "components/Common/TooltipCustom";

interface CustomParametersFormProps {
  formik: any;
  disabled?: boolean;
  lang: string;
}

const PARAM_DEFAULT = {
  course: "",
  number_of_courses: 0,
  started_at: new Date(),
  expired_at: new Date(new Date().setDate(new Date().getDate() + 120)),
  status: 1,
  id: "",
};

const CourseList = ({
  formik = "",
  disabled = false,
  lang = "en",
}: CustomParametersFormProps) => {
  const { t } = useTranslation();
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [indexDelete, setIndexDelete] = useState<any>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const ref = useRef(null);
  const onCloseConfirmClick = () => {
    setIsOpenConfirm(false);
    setIndexDelete(null);
    setIsConfirmLoading((_prev) => false);
  };

  const handleAddItem = () => {
    formik.setFieldValue("courses", [
      ...formik?.values?.courses,
      { ...PARAM_DEFAULT },
    ]);
  };

  const handleRemoveItem = (index: number) => {
    const updatedItems = formik?.values?.courses?.filter(
      (_: any, i: any) => i !== index
    );
    formik.setFieldValue("courses", updatedItems);
  };

  const handleActionDelete = async () => {
    try {
      handleRemoveItem(indexDelete);
      setIsOpenConfirm(false);
      toast(
        `${t("The process has been completed.")}`,
        CONFIG_OPTION_TOAST_NORMAL
      );
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      setIndexDelete(null);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
    setIsConfirmLoading((_prev) => false);
  };

  return (
    <React.Fragment>
      <>
        <Col lg={12}>
          <Label
            htmlFor="titleKoreaInput"
            className="form-label d-flex align-items-center gap-1"
          >
            <div>
              {t("List Course")} <span className="text-danger">*</span>{" "}
            </div>
            <TooltipCustom
              title={t(
                "This is the course list, the course will be done according to the subtitle selection"
              )}
              className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
              style={{
                transform: "translateY(2px)",
              }}
            >
              <i
                className="ri-question-line align-bottom text-secondary"
                style={{ fontSize: "16px" }}
              ></i>
            </TooltipCustom>
          </Label>

          <table className="w-100">
            <thead>
              <tr style={{ background: "#EDEDED", height: "37px" }}>
                {/* <th style={{width: 70, textAlign: "center"}}>{t("Status")}</th> */}
                <th style={{ paddingLeft: "10px" }}>{t("Courses")}</th>
                <th>{t("Thumbnail")}</th>
                <th>{t("Category")}</th>
                <th>{t("Language")}</th>
                <th>{t("Chapters")}</th>
                <th>{t("Lectures")}</th>
                <th>{t("Price USD/ Price KRW")}</th>
                <th>{t("")}</th>
              </tr>
            </thead>
            <tbody>
              {formik?.values?.courses &&
                formik?.values?.courses?.map((item: any, index: number) => {
                  return (
                    <tr key={`${index}`}>
                      <td
                        style={{
                          padding: "5px 10px",
                          verticalAlign: "baseline",
                          maxWidth: "260px",
                        }}
                      >
                        <div className="d-flex gap-2 align-items-center">
                          <div style={{ width: "100%", minWidth: "260px" }}>
                            <DropdownAsyncCourse
                              name={`courses.${index}.id`}
                              onChangeSelect={(event: any) => {
                                const i = formik?.values?.courses?.findIndex(
                                  (i: any) => i?.id === event?.value
                                );

                                if (i >= 0) {
                                  return;
                                } else {
                                  formik.setFieldValue(`courses.${index}`, {
                                    ...event,
                                    id: event?.value,
                                  });
                                  //   formik.setFieldValue(
                                  //     `courses.${index}.number_of_courses`,
                                  //     1
                                  //   );
                                }
                              }}
                              lang={lang}
                              isMulti={false}
                              placeholder={`${t("Select Course")}...`}
                              isShowIconCheck={false}
                              isAllOption={false}
                              listCheckedCourse={item?.data}
                              isClearable={false}
                              isDisabled={disabled}
                            />
                          </div>
                        </div>
                        {formik.errors.courses &&
                        (
                          formik.touched.courses?.[
                            index
                          ] as FormikErrors<ICourse>
                        )?.id &&
                        (formik.errors.courses[index] as FormikErrors<ICourse>)
                          ?.id ? (
                          <small className="text-danger mt-2">
                            {((
                              formik.errors.courses[
                                index
                              ] as FormikErrors<ICourse>
                            )?.id as String) ?? ""}
                          </small>
                        ) : null}
                      </td>
                      <td
                        style={{
                          paddingRight: "10px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          verticalAlign: "baseline",
                        }}
                      >
                        {!!item?.data?.thumbnail && (
                          <img
                            src={item?.data?.thumbnail}
                            alt="thumbnail"
                            style={{ width: "auto", height: 60 }}
                          />
                        )}
                      </td>
                      <td
                        style={{
                          paddingRight: "10px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          verticalAlign: "baseline",
                        }}
                      >
                        <p>{item?.data?.category?.name}</p>
                      </td>
                      <td
                        style={{
                          paddingRight: "10px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          verticalAlign: "baseline",
                        }}
                      >
                        {
                          LIST_LANGUAGE_OPTION.find(
                            (i) => i.value === item?.data?.lang
                          )?.label
                        }
                      </td>
                      <td
                        style={{
                          paddingRight: "10px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          verticalAlign: "baseline",
                        }}
                      >
                        <b>{item?.data?.total_chapters}</b>
                      </td>
                      <td
                        style={{
                          paddingRight: "10px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          verticalAlign: "baseline",
                        }}
                      >
                        <b>{item?.data?.total_lectures}</b>
                      </td>

                      <td
                        style={{
                          paddingRight: "10px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          verticalAlign: "baseline",
                        }}
                      >
                        {(item?.data?.price_en || item?.data?.price_kr) && (
                          <b>
                            {new Intl.NumberFormat().format(
                              item?.data?.price_en || 0
                            )}
                            /{" "}
                            {new Intl.NumberFormat().format(
                              item?.data?.price_kr || 0
                            )}
                          </b>
                        )}
                      </td>

                      <td>
                        {!disabled && (
                          <div
                            className="d-flex"
                            style={{
                              justifyContent: "center",
                              paddingRight: "10px",
                            }}
                          >
                            <div>
                              {
                                <div
                                  className="text-danger cursor-pointer"
                                  onClick={() => {
                                    setIsOpenConfirm(true);
                                    setIndexDelete(index);
                                  }}
                                >
                                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                                </div>
                              }
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Col>

        <Col lg={12}>
          {formik.errors.courses &&
          typeof formik.errors.courses === "string" ? (
            <div className="text-danger mt-2">
              {formik.errors.courses as string}
            </div>
          ) : null}
        </Col>

        {!disabled && (
          <Col lg={12}>
            <div
              className="text-primary text-center cursor-pointer mt-3 d-flex align-items-center justify-content-center gap-2"
              style={{ fontSize: 30, background: "#0bcee91c" }}
              onClick={handleAddItem}
            >
              + <span style={{ fontSize: 14 }}>{t("Add Course")}</span>
            </div>
          </Col>
        )}
      </>

      <ModalConfirm
        header={t("Delete this course")}
        isOpen={isOpenConfirm}
        isLoading={isConfirmLoading}
        onClose={onCloseConfirmClick}
        onConfirm={handleActionDelete}
      />
    </React.Fragment>
  );
};

export default CourseList;
